import { SWReactIcons } from "@similarweb/icons";
import { Badge, PlainTooltip } from "@similarweb/ui-components";

import { MetricIconCell } from "app/components/React/Table/cells";
import { LeadersHighestLowestCell } from "app/components/React/Table/cells/LeadersHighestLowestCell";
import { DefaultCellHeader } from "app/components/React/Table/headerCells";
import { AppHeaderWithMarker } from "app/components/React/Table/headerCells/AppHeaderWithMarker";
import { column } from "app/components/React/Table/SWReactTableDefaults";
import { translate } from "app/filters/i18nFilter";
import type { IAppsEngagementTableColumns } from "app/pages/app-intelligence/app-analysis/pages/Engagement/components/types";
import type { ITabMetaData } from "app/pages/app-intelligence/types";

import { IconWrapper, MetricField } from "./styledComponents";

export const dateToUTC = (dateString) => {
    if (dateString) {
        const date = dateString.split("-");
        return Date.UTC(parseInt(date[0], 10), parseInt(date[1], 10) - 1, parseInt(date[2], 10));
    }
};
export const getManagedTableData = (verticals, tableData, translate) => {
    return verticals.meta.reduce((verticalAcc, currentVertical) => {
        const appsDataOfMetric = getRowDataOfAllApps(currentVertical, tableData);
        return [
            ...verticalAcc,
            {
                metric: { value: translate(currentVertical.title), icon: currentVertical.icon },
                ...appsDataOfMetric,
            },
        ];
    }, []);
};

const getRowDataOfAllApps = (currentVertical, tableData) => {
    const appsDataOfMetric = tableData.reduce((appAcc, appCurrentValue) => {
        return {
            ...appAcc,
            [appCurrentValue.App]: {
                format: currentVertical.filter,
                ...appCurrentValue[currentVertical.name],
            },
        };
    }, {});
    return appsDataOfMetric;
};

const metricColumnWithTooltip = (meta: ITabMetaData | undefined) =>
    column({
        field: "metric",
        displayName: "Metric",
        headerComponent: DefaultCellHeader,
        visible: true,
        format: "None",
        cellComponent: ({ rowIndex, value }) => {
            if (meta && meta[rowIndex].withTableTooltip) {
                return (
                    <MetricField>
                        <MetricIconCell value={value} />
                        <PlainTooltip
                            placement="top"
                            tooltipContent={translate(meta[rowIndex].infoIcon)}
                        >
                            <IconWrapper>
                                <SWReactIcons
                                    size="xs"
                                    iconName="info"
                                />
                            </IconWrapper>
                        </PlainTooltip>
                        {meta[rowIndex].isNew ? <Badge type="new" /> : null}
                    </MetricField>
                );
            }

            return <MetricIconCell value={value} />;
        },
    });

export const getTableColumns = (
    selectedApps: IAppsEngagementTableColumns[],
    isForDashboardWidget,
    meta: ITabMetaData | undefined,
): any[] => {
    const selectedAppsTableColumns = selectedApps.map((col) =>
        column({
            field: col.Id,
            displayName: col.Title,
            headerComponent: AppHeaderWithMarker,
            cellComponent: LeadersHighestLowestCell,
        }),
    );
    const allColumns = [metricColumnWithTooltip(meta), ...selectedAppsTableColumns];

    return isForDashboardWidget ? allColumns.map((col) => ({ ...col, title: col.displayName })) : allColumns;
};
